<template>
  <div>
    <!-- Overlay For Sidebars -->
    <div class="overlay"></div>
    <div
        style="position: fixed;top: 0;left: 0;bottom: 0;background-color: #f3f3f5;z-index: 999;width: 100%;height: 100%;text-align: right;direction: rtl;padding: 5px;"
        v-show="$store.state.menuShow">
      <div class="bg-white p-2 mb-2 text-left">
        <span @click="$store.state.menuShow=false" style="cursor: pointer;">
          بستن
        </span>
      </div>
      <div class="bg-white p-2 mb-2">
        <span v-if="userInfo.Gender === true">
          آقای
        </span>
        <span v-else-if="userInfo.Gender === false">
          خانم
        </span>
        <span>
          {{ userInfo.FirstName + " " + userInfo.LastName }}
        </span>
        <small>خوش آمدید</small>
      </div>
      <div class="bg-white p-2">
        <ul class="m-0 p-r-0" style="list-style: none;">
          <li>
            <a href="#" @click="signOut()" style="position: relative;">
              <i class="zmdi zmdi-power" style="top:3px;position: absolute;"></i>
              <span style="margin-right: 18px;">
                خروج
              </span>
            </a>
          </li>
        </ul>
      </div>

    </div>

    <!-- Main Search -->
    <!--    <div id="search">
          <button
              id="close"
              type="button"
              class="close btn btn-primary btn-icon btn-icon-mini btn-round"
          >x
          </button>
          <form>
            <input type="search" value placeholder="جستجو..."/>
            <button type="submit" class="btn btn-primary">جستجو</button>
          </form>
        </div>-->

    <!-- Right Icon menu Sidebar -->
    <!--    <div class="navbar-right">
          <ul class="navbar-nav">
            <li>
              <a href="#search" class="main_search" title="Search...">
                <i class="zmdi zmdi-search"></i>
              </a>
            </li>

            <li>
              <a href="#" class="mega-menu" title="خروج از پنل کاربری" @click="signOut()">
                <i class="zmdi zmdi-power"></i>
              </a>
            </li>
          </ul>
        </div>-->

    <!-- Left Sidebar -->
    <!--    <aside id="leftsidebar" class="sidebar">
          <div class="navbar-brand">
            <button class="btn-menu ls-toggle-btn" type="button">
              <i class="zmdi zmdi-menu"></i>
            </button>
            <a href="#">
              <img src="/assets/images/logo.svg" width="25" alt="Aero"/>
              <span class="m-l-10">پنل مدیریت</span>
            </a>
          </div>
          <div class="menu">
            <ul class="list">
              <li>
                <div class="user-info">
                  <a class="image" href="profile.html">
                    <img src="/assets/images/profile_av.jpg" alt="User"/>
                  </a>
                  <div class="detail">
                    <h4>
                      <span v-if="userInfo.Gender === true">
                        آقای
                      </span>
                      <span v-else-if="userInfo.Gender === false">
                        خانم
                      </span>
                      {{ userInfo.FirstName + " " + userInfo.LastName }}
                    </h4>
                    <small>خوش آمدید</small>
                  </div>
                </div>
              </li>
              <li>
                <a @click="loadModule('Dashboard')" style="cursor: pointer;">
                  <i class="zmdi zmdi-home"></i>
                  <span>داشبورد</span>
                </a>
              </li>
              <li>
                <a @click="loadModule('OrderManagement')" style="cursor: pointer;">
                  <i class="zmdi zmdi-home"></i>
                  <span>مدیریت سفارشات</span>
                </a>
              </li>
              <li>
                <a @click="loadModule('InvoiceNotes')" style="cursor: pointer;">
                  <i class="zmdi zmdi-home"></i>
                  <small style="right: initial;" class="text-danger">
                    (جدید {{ invoiceNoteCount }})
                  </small>
                </a>
              </li>
              <li v-for="item in userModules" :key="item._id">
                <a @click="loadModule(item.Modules.Name)" style="cursor: pointer;" :class="{ 'menu-toggle toggled': item.Modules.SubModules.length > 0 }" class="waves-effect waves-block">
                  <i class="zmdi zmdi-menu"></i>
                  <span>{{ item.Modules.Title }}</span>
                </a>
                <ul style="list-style: none;">
                  <li v-for="(subModule,index) in item.Modules.SubModules" :key="index">
                    <a class="submodule pb-0" @click="loadModule(subModule.EnModuleName)" style="cursor: pointer;">
                      {{subModule.FaModuleName}}
                    </a>
                  </li>
                </ul>
              </li>

            </ul>
          </div>
        </aside>-->

    <!-- Right Sidebar -->


    <!-- <section class="content"> -->
    <!--    <component :is="$store.state.contentPane"></component>-->
    <component :is="$route.params.modulename"></component>
    <!-- </section> -->
  </div>


</template>
<script>
/* eslint-disable */
import axios from "axios";
import Dashboard from "../components/ManagerPanel/Dashboard.vue";
// import NewTodo from "../components/NewTodo.vue";
import UserList from "../components/KhorshidShab/UserList";
// import PostList from "../components/ManagerPanel/PostList";
// import CategoriesList from "../components/ManagerPanel/CategoriesList";
// import TopMenuList from "../components/ManagerPanel/TopMenuList";
// import MeetingBoardList from "../components/ManagerPanel/MeetingBoardList";
// import MeetingsAddressesList from "../components/ManagerPanel/MeetingsAddressesList";
// import DailyQuoteList from "../components/ManagerPanel/DailyQuoteList";
// import NewsList from "../components/ManagerPanel/NewsList";
// import GalleryList from "../components/ManagerPanel/GalleryList";
// import ContactusList from "../components/ManagerPanel/ContactusList";
// import PostCommentList from "../components/ManagerPanel/PostCommentList";
// import PushNotificationList from "../components/ManagerPanel/PushNotificationList";
// import CoursesList from "../components/ManagerPanel/CoursesList";
// import FactorList from "../components/ManagerPanel/FactorList";
// import CalcInstallment from "../components/ManagerPanel/CalcInstallment";
// import Vue from "vue";
// import ShopList from "./ManagerPanel/ShopList";
// import SlideShowManager from "./ManagerPanel/SlideShowManager";
// import ProductsList from "./ManagerPanel/ProductsList";
// import OfficesList from "./ManagerPanel/OfficesList";
// import CounterOffices from "./ManagerPanel/CounterOffices";
// import BannersManager from "./ManagerPanel/BannersManager";
// import CustomerClubManager from "./ManagerPanel/CustomerClubManager";
// import ShopCommentsManager from "./ManagerPanel/ShopCommentsManager";
// import InstallmentsManager from "./ManagerPanel/InstallmentsManager";
// import CustomerValidation from "./ManagerPanel/CustomerValidation";
// import NoticesManager from "./ManagerPanel/NoticesManager";
import DashboardManager from "./ManagerPanel/DashboardManager";
import IncomingRemittancesManager from "./ManagerPanel/IncomingRemittancesManager";
import ShipmentManager from "./ManagerPanel/ShipmentManager.vue";
import ShipmentPanel from "./ShipmentMnager/ShipmentPanel.vue";
import ProductionPlanningPanel from "./ShipmentMnager/ProductionPlanningPanel.vue";
import OrderingPanel from "./ShipmentMnager/OrderingPanel.vue";
import InspectorPanel from "./ShipmentMnager/InspectorPanel.vue";
import LogisticsPanel from "./ShipmentMnager/LogisticsPanel.vue";
import OrderManagement from "./KhorshidShab/OrderManagement.vue";
import OrderManagementNew from "./KhorshidShab/OrderManagementNew.vue";
import ChatbotManagement from "./KhorshidShab/ChatbotManagement.vue";
import CustomerClub from "./KhorshidShab/CustomerClub.vue";
import InvoiceNotes from "./KhorshidShab/InvoiceNotesManagement.vue";
import ReportList from "./KhorshidShab/ReportList.vue";
// import WalletTransactionsList from "./ManagerPanel/WalletTransactionsList";

export default {
  name: "app",
  data() {
    return {
      userModules: [],
      userInfo: {},
      invoiceNoteCount: 0
    };
  },

  methods: {
    getModulesList() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      axios
          .get("/GetUserModulesByToken", {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (response) {
            console.log(response.data)
            //console.log("لیست ماژول ها", response.data);
            self.userModules = response.data.Data;
          })
          .catch(function (error) {
          });
    },
    loadModule(moduleName) {
      let self = this;
      console.log(moduleName);
      const currentModuleName = self.$route.params.modulename;
      console.log(currentModuleName);
      if (currentModuleName !== moduleName) {
        self.$router.replace({path: `/userpanel/${moduleName}`});
      }
      // self.$store.state.contentPane = moduleName;
    },
    getUserInfo() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      //console.log(userInfo);
      axios
          .get("https://araksolar.ir/webhook/GetUserInfo", {
            headers: {
              Authorization: userInfo.Token
            }
          })
          .then(function (res) {
            console.log(res.data);
            let {Status} = res.data[0];
            if (Status === 1) {
              self.userInfo = res.data[0].UserInfo;
              self.invoiceNoteCount = res.data[0].InvoiceNoteCount.InvoiceNoteCount;
            } else if (Status === -1) {
              localStorage.removeItem("UserInfo");
              self.$router.push("/login");
            }
          })
          .catch(function (error) {
          });
    },
    signOut() {
      // self.loadingShow=true;
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      if (userInfo != null) {
        localStorage.removeItem("UserInfo");
        self.$router.push("/login");
      }
    }
  },
  created() {
    let self = this;
    const currentModuleName = self.$route.params.modulename;
    if (currentModuleName === undefined) {
      self.$router.replace({path: `/userpanel/Dashboard`});
    }
    //this.getModulesList();
    self.getUserInfo();
  },
  components: {
    Dashboard,
    UserList,
    IncomingRemittancesManager,
    ShipmentManager,
    ShipmentPanel,
    ProductionPlanningPanel,
    OrderingPanel,
    InspectorPanel,
    LogisticsPanel,
    OrderManagement,
    OrderManagementNew,
    ChatbotManagement,
    InvoiceNotes,
    ReportList,
    // CalcInstallment,
    // PostList,
    // CategoriesList,
    // TopMenuList,
    // MeetingBoardList,
    // MeetingsAddressesList,
    // DailyQuoteList,
    // NewsList,
    // GalleryList,
    // ContactusList,
    // PostCommentList,
    // PushNotificationList,
    // CoursesList,
    // FactorList,
    // ShopList,
    // SlideShowManager,
    // ProductsList,
    // OfficesList,
    // CounterOffices,
    // BannersManager,
    // CustomerClubManager,
    // ShopCommentsManager,
    // InstallmentsManager,
    // CustomerValidation,
    // NoticesManager,
    DashboardManager,
    CustomerClub
    // WalletTransactionsList
  },
  head: {
    title: {
      inner: "پنل مدیریت"
    },
    meta: [
      {name: "application-name", content: "Name of my application"},
      {name: "description", content: "A description of the page", id: "desc"}, // id to replace intead of create element
      // ...
      // Twitter
      {name: "twitter:title", content: "Content Title"},
      // with shorthand
      {
        n: "twitter:description",
        c: "Content description less than 200 characters"
      },
      // ...
      // Google+ / Schema.org
      {itemprop: "name", content: "Content Title"},
      {itemprop: "description", content: "Content Title"},

      {property: "fb:app_id", content: "123456789"},
      {property: "og:title", content: "Content Title"},
      {p: "og:image", c: "https://example.com/image.jpg"}
    ],
    link: [
      {
        rel: "canonical",
        href: "http://example.com/#!/contact/",
        id: "canonical"
      },
      {rel: "author", href: "author", undo: false}
      // {
      //   rel: "stylesheet",
      //   href: require("../../public/assets/plugins/bootstrap/css/bootstrap.min.css"),
      //   type: "text/css"
      // },
      // {
      //   rel: "stylesheet",
      //   href: require("../../public/assets/plugins/jquery-datatable/dataTables.bootstrap4.min.css"),
      //   type: "text/css"
      // },
      // {
      //   rel: "stylesheet",
      //   href: require("../../public/assets/css/style.min.css"),
      //   type: "text/css"
      // }
    ],
    script: [
      // {
      //   type: "text/javascript",
      //   src: "cdn/to/script.js",
      //   async: true,
      //   body: true
      // }
    ],
    style: [
      // {
      //   type: "text/css",
      //   href: "",
      //   undo: false
      // }
    ]
  },
  beforeCreate() {
    document.body.className = "theme-blush";
    /*var link1 = document.createElement("link");
    link1.rel = "stylesheet";
    link1.href = "assets/plugins/bootstrap/css/bootstrap.min.css";
    document.head.appendChild(link1);

    var link2 = document.createElement("link");
    link2.rel = "stylesheet";
    link2.href =
      "assets/plugins/jquery-datatable/dataTables.bootstrap4.min.css";
    document.head.appendChild(link2);

    var link3 = document.createElement("link");
    link3.rel = "stylesheet";
    link3.href = "assets/css/style.min.css";
    document.head.appendChild(link3);*/
    //تا اینجا

    /*var script1 = document.createElement("script");
    script1.src = require("../../public/assets/plugins/ckeditor/ckeditor.js");
    document.body.appendChild(script1);

    var script2 = document.createElement("script");
    script2.src = require("../../public/assets/js/pages/forms/editors.js");
    document.body.appendChild(script2);*/
  }
};
</script>
<style scoped>
/* @import "../../public/assets/plugins/bootstrap/css/bootstrap.min.css";
@import "../../public/assets/plugins/jquery-datatable/dataTables.bootstrap4.min.css";
@import "../../public/assets/css/style.min.css"; */
a.submodule:before {
  font-size: 12px;
  color: #999;
  content: '\f2ff';
  position: absolute;
  right: -6px;
  font-family: 'Material-Design-Iconic-Font';
  top: 17px;
}
</style>
